<template>
  <main class="card hidden_overflow_tabela px-2 mt-2">
    <modal-processed-work-orders
        :showModal="showModalProcessedWorkOrders"
        :items="processedWorkOrders"
        @download="downloadZipOs"
        @confirmed="closeModalProcessedWorkOrders()"
    />
    <validation-observer>
      <b-form>
        <b-row class="align-items-start">

          <b-col
              sm="12"
              lg="6"
              class="px-1"
          >

              <CpfCnpjInput
                  v-if="showIdentifierCompanyMask"
                  input-id="identifier_company"
                  v-model="form.identifier_company"
                  label="CNPJ/CPF"
              />
              <small  v-if="errorApi.cnpj" class="text-danger">{{ errorApi.cnpj }}</small>
          </b-col>

          <b-col
              sm="12"
              lg="6"
              class="px-1"
          >
            <company-input-filter
              v-model="form.company_name"
              :form="form"
            />
          </b-col>
        </b-row>

        <b-row class="align-items-start">
          <b-col
              sm="6"
              lg="3"
          >
            <b-form-group
                label="Data de início"
                label-for="data-input-inicio"
                label-class="font_size_label"
            >
              <validation-provider
                  #default="{ errors }"
                  name="data de início"
                  :rules="{ date_format: true }">
                <b-input-group>
                  <b-form-input
                      id="data-input-inicio"
                      v-model="inputDateStart"
                      v-mask="'##/##/####'"
                      class="form-control"
                      :state="inputDateStart > 0 ? false:null"
                      placeholder="00/00/0000"
                      autocomplete="off"
                      @input="setDateStartInput"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.date_start"
                        class="form-control d-flex align-items-center"
                        locale="pt-BR"
                        button-only
                        right
                        :hide-header="true"
                        label-help="Selecione a data de início"
                        button-variant="custom-blue"
                        clearable
                        @input="setDateStartPicker"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small v-if="errors && errors.length > 0" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
              sm="6"
              lg="3"
          >
            <b-form-group
                label="Data de fim"
                label-for="data-input-fim"
                label-class="font_size_label"
            >
              <validation-provider
                  #default="{ errors }"
                  name="data de fim"
                  :rules="{ date_format: true, date_range: inputDateStart }">
                <b-input-group>
                  <b-form-input
                      id="data-input-fim"
                      v-model="inputDateEnd"
                      v-mask="'##/##/####'"
                      class="form-control"
                      :state="inputDateEnd > 0 ? false:null"
                      placeholder="00/00/0000"
                      autocomplete="off"
                      @input="setDateEndInput"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.date_end"
                        class="form-control d-flex align-items-center"
                        locale="pt-BR"
                        button-only
                        right
                        :hide-header="true"
                        label-help="Selecione a data fim"
                        button-variant="custom-blue"
                        clearable
                        @input="setDateEndPicker"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small v-if="errors && errors.length > 0" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
              lg="6"
              sm="12"
          >
            <b-form-group
                label="Status"
                label-class="font_size_label"
                label-for="status"
            >
              <validation-provider
                  #default="{errors}"
                  name="status"
              >
                <v-select
                    id="status"
                    v-model="form.status"
                    :options="statusOptions"
                    placeholder="Selecione o status"
                    label="descricao"
                    item-text="status"
                    item-value="status"
                    :clearable="false"
                >
                  <small v-if="errors && errors.length > 0" class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="align-items-center">
          <b-col
              lg="6"
              sm="12"
          >
          <b-form-group
                v-if="!isAdminEmpresa"
                label="Departamento"
                label-class="font_size_label"
                label-for="departamento"
            >
              <validation-provider
                  #default="{errors}"
                  name="Departamento"
              >
                <v-select
                    id="departamento"
                    v-model="form.department"
                    :options="departmentOptions"
                    placeholder="Selecione o departamento"
                    label="descricao"
                    item-text="descricao"
                    item-value="id_departamento"
                    append-to-body
                >
                  <small class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </validation-provider>
            </b-form-group>
            <b-form-group
                v-else
                label="Estado"
                label-class="font_size_label"
                label-for="estado"
            >
              <validation-provider
                  #default="{errors}"
                  name="Estado"
              >
                <v-select
                    id="estado"
                    v-model="form.department"
                    :options="departmentOptions"
                    placeholder="Selecione o estado"
                    label="estado"
                    item-text="estado"
                    item-value="id_departamento"
                    append-to-body
                >
                  <small class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              lg="6"
              sm="12"
          >
          <b-form-group
                label="Unidade Operacional"
                label-class="font_size_label"
                label-for="unit"
            >
              <validation-provider
                  #default="{errors}"
                  name="Unidade operacional"
              >
                <v-select
                    id="unit"
                    v-model="form.operating_unit"
                    :options="operatingOptions"
                    placeholder="Selecione a unidade operacional"
                    label="descricao_unidade"
                    item-text="descricao_unidade"
                    item-value="id_unidade"
                    :clearable="false"
                    append-to-body
                >
                  <small class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="align-items-center">
          <b-col
              lg="6"
              sm="12"
          >
          <b-form-group
                label="Campanha"
                label-class="font_size_label"
                label-for="campanha"
            >
              <validation-provider
                  #default="{errors}"
                  name="Campanha"
              >
                <v-select
                    id="campanha"
                    v-model="form.campaign"
                    :options="campaignOptions"
                    placeholder="Selecione a campanha"
                    label="campanha_descricao"
                    item-text="campanha_descricao"
                    item-value="id_campanha"
                    append-to-body
                >
                  <small class="text-danger">{{ errors[0] }}</small>
                </v-select>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
    <Filters
        :disableButtonSearch="isSearchDisable"
        @actionSearch="search"
        @actionClear="clear"
    />
    <b-row align-h="between">
      <b-col
          lg="6"
          md="6"
          sm="6"
          class="col-12 mb-sm-0"
      >
        <div class="d-flex justify-center-center align-items-center">
          <span
              class="mr-1"
              for="tableSize"
          >
            Mostrar
          </span>
          <v-select
              id="tableSize"
              v-model="defaultSize"
              :options="optionsSize"
              :clearable="false"
              class="customizeDifferentSpace"
              @input="fireEventFilter"
              style="width: 87px;"
              append-to-body
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
          <b-button v-show="canGenerateOS && showOsProcessedBtn" @click="openModalProcessedWorkOrders" class="os-btn ml-2">
            <span class="align-middle">Ordens de Serviço Processadas</span>
          </b-button>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm=6>
        <ButtonDownloadSpreadsheet type="Agendamentos" :parameters="parameters" :size="paginationTotalLines"
                                   :isEmpty="tableItemsLength === 0" tooltip-text="Exportar agendamentos" />
      </b-col>
    </b-row>
  </main>

</template>

<script>

import {
  BButton,
  BCol, BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BRow, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import moment from 'moment/moment'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import Filters from '@/views/components/custom/filters/Filters.vue'
import tourSchedulingMixin from '../mixins/tourSchedulingMixin'
import CompanyInputFilter from '@/views/components/custom/empresa/CompanyInputFilter.vue';
import CpfCnpjInput from '@/views/components/custom/empresa/CpfCnpjInput.vue'
import { actions, subjects } from '@/libs/acl/rules'
import ModalProcessedWorkOrders from "@/views/components/custom/modals/agendamento/ordem-de-servico/ModalProcessedWorkOrders.vue";
import ModalProcessing from "@/views/components/custom/modals/agendamento/ordem-de-servico/ModalProcessing.vue";
import ButtonDownloadSpreadsheet from "@/views/components/button-download-spreadsheet/ButtonDownloadSpreadsheet.vue";

extend("date_range", {
  params: ["startDate"],
  message: "A data de início não pode ser maior que a data de fim",
  validate: (endDate, { startDate }) => {
    if (startDate == '' || endDate == '') return true;
    return moment(startDate, 'DD-MM-YYYY').isBefore(moment(endDate, 'DD-MM-YYYY'));
  }
});

extend("date_format", {
  message: "Informe uma data válida",
  validate: (value) => {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!regex.test(value)) return false;

    const [day, month, year] = value.split("/").map(Number);
    const date = new Date(year, month - 1, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
  }
});

export default {
  components: {
    ButtonDownloadSpreadsheet,
    ModalProcessing,
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    Filters,
    ValidationObserver,
    ValidationProvider,
    CompanyInputFilter,
    CpfCnpjInput,
    ModalProcessedWorkOrders
  },
  mixins: [tourSchedulingMixin],
  props: {
    filter: {
      required: false,
      default: false,
    },
    parameters: {
      type: Object,
      required: false,
    },
    paginationTotalLines: {
      type: Number,
      required: false,
    },
    tableItemsLength: {
      type: Number,
      required: false,
    },
    errorApi: {
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      filterForm: true,
      form: {
        identifier_company: '',
        company_name: '',
        date_start: moment().startOf('year').format('DD-MM-YYYY'),
        date_end: moment().format('DD-MM-YYYY'),
        operating_unit: '',
        department: '',
        campaign: '',
        status: '',
        company_name_filter: 'nome_fantasia',
      },
      searchFilter: {},
      inputDateStart: moment().startOf('year').format('DD-MM-YYYY'),
      inputDateEnd: moment().format('DD-MM-YYYY'),
      statusOptions: ['Agendado', 'Finalizado', 'Cancelado', 'Repescagem'],
      operatingOptions: [],
      campaignOptions: [],
      departmentOptions: [],
      showIdentifierCompanyMask: true,
      defaultSize: 10,
      optionsSize: [10, 25, 50, 100],
      error: {
        cnpj: null
      },
      showOsProcessedBtn: false,
      showModalProcessedWorkOrders: false,
      processedWorkOrders: [],
      canGenerateOS:
          this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI) ||
          this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI_SAUDE_REGIAO),
    }
  },
  computed: {
    isSearchDisable() {
      return (this.inputDateStart !== '' &&
             this.inputDateEnd !== '' &&
             !moment(this.inputDateStart, 'DD-MM-YYYY').isBefore(moment(this.inputDateEnd, 'DD-MM-YYYY')));
    },
     isAdminEmpresa() {
      return this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_AE);
    },

  },
  mounted() {
    if(this.loadData){
      this.getUnits()
      this.getCampaigns()
      this.getDepartments()
      this.start()

      if (this.canGenerateOS) {
        this.$http.get(this.$api.getOSProcessedByUser()).then(({data}) => {
          this.showOsProcessedBtn = data.length > 0;
          this.processedWorkOrders = data;
        })
      }
    }
  },
  methods: {
    loadOSProcessedByUser() {
      this.$http.get(this.$api.getOSProcessedByUser()).then(({ data }) => {
        this.showOsProcessedBtn = data.length > 0;
        this.processedWorkOrders = data;

        if (data.length === 0) {
          this.showModalProcessedWorkOrders = false;
        }

      })
    },
    setDateStartInput() {
      if (this.inputDateStart && this.inputDateStart.length == 0) {
        this.form.date_start = null
      } else if (this.inputDateStart && this.inputDateStart.length == 10) {
        this.form.date_start = moment(this.inputDateStart, 'DD/MM/YYYY').format('YYYY-MM-DD')
      } else {
        this.form.date_start = this.inputDateStart
      }
    },
    setDateEndInput() {
      if (this.inputDateEnd && this.inputDateEnd.length == 0) {
        this.form.date_end = null
      } else if (this.inputDateEnd && this.inputDateEnd.length == 10) {
        this.form.date_end = moment(this.inputDateEnd, 'DD/MM/YYYY').format('YYYY-MM-DD')
      } else {
        this.form.date_end = this.inputDateEnd
      }
    },
    setDateStartPicker() {
      this.inputDateStart = moment(this.form.date_start).format('DD/MM/YYYY')
    },
    setDateEndPicker() {
      this.inputDateEnd = moment(this.form.date_end).format('DD/MM/YYYY')
    },
    getUnits() {
      const isAgendamentoAE = this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_AE)

      const parameters = isAgendamentoAE
        ? { ativo: true, id_departamento: this.form.department?.id_departamento || null }
        : {
            ativo: true,
            id_departamento: this.form.department?.id_departamento || null,
            todos: !!this.form.department?.id_departamento,
          }

      const apiRoute = isAgendamentoAE
        ? this.$api.getUnitiesByScheduling()
        : this.$api.unidade()

      this.$http.get(apiRoute, { params: parameters }).then(({ data }) => {
        this.operatingOptions = data
      })
    },

    getCampaigns() {
      const isAgendamentoAE = this.isAdminEmpresa;
      let parameters = { uf: this.form.department?.uf };
      if (!isAgendamentoAE) {
        parameters = {
          ...parameters,
          trazerTodasAsCampanhas: parameters.uf ? 1 : 0,
        }
      }

      this.$http.get(this.$api.campanha(), { params: parameters }).then(({ data }) => {
        this.campaignOptions = data
      })
    },

    getDepartments() {
      const isAgendamentoAE = this.isAdminEmpresa;
      let parameters =  null;
      if (!isAgendamentoAE) {
        parameters = { todos: true }
      }

      this.$http.get(this.$api.departamento(), { params: parameters }).then(({ data }) => {
        this.departmentOptions = data
      })

    },
    start() {
      this.searchFilter = {
        route: this.$router.currentRoute.name,
        column_order: 'asc',
        nome_fantasia: this.form.company_name,
        company_name_filter: this.form.company_name_filter,
        cnpj: this.form.identifier_company,
        data_inicio: this.form.date_start,
        data_fim: this.form.date_end,
        unidade_operacional: this.form.operating_unit.id_unidade,
        status: this.form.status,
        filter: this.filter,
        porPagina: this.defaultSize,
      }
      this.$emit('filterTable', this.searchFilter)
    },
    fireEventFilter() {
      this.searchFilter = {
        route: this.$router.currentRoute.name,
        column_order: 'asc',
        nome_fantasia: this.form.company_name,
        company_name_filter: this.form.company_name_filter,
        cnpj: this.form.identifier_company,
        data_inicio: this.form.date_start,
        data_fim: this.form.date_end,
        unidade_operacional: this.form.operating_unit.id_unidade,
        campanha: this.form.campaign.id_campanha,
        departamento: this.form.department.id_departamento,
        status: this.form.status,
        filter: this.filter,
        porPagina: this.defaultSize,
        pagina: 1,
      }

      this.$emit('filterTable', this.searchFilter)
    },
    search() {
      this.searchFilter = {
        porPagina: this.defaultSize,
        route: this.$router.currentRoute.name,
        column_order: 'asc',
        nome_fantasia: this.form.company_name,
        company_name_filter: this.form.company_name_filter,
        cnpj: this.form.identifier_company,
        data_inicio: this.form.date_start,
        data_fim: this.form.date_end,
        unidade_operacional: this.form.operating_unit?.id_unidade,
        campanha: this.form.campaign?.id_campanha,
        departamento: this.form.department?.id_departamento,
        status: this.form.status,
        pagina: 1,
      }

      this.$emit('filterTable', this.searchFilter)
    },
    clear() {
      this.showIdentifierCompanyMask = false
      this.form.company_name = ''
      this.form.company_name_filter = 'nome_fantasia'
      this.form.identifier_company = ''
      this.form.date_start = ''
      this.form.date_end = ''
      this.inputDateStart = ''
      this.inputDateEnd = ''
      this.form.operating_unit = ''
      this.form.department = ''
      this.form.campaign = ''
      this.form.status = ''
      this.defaultSize = 10

      this.$nextTick(() => {
        this.showIdentifierCompanyMask = true
        this.searchFilter = {
          defaultSize: this.defaultSize,
          route: this.$router.currentRoute.name,
          column_order: 'asc',
          nome_fantasia: this.form.company_name,
          company_name_filter: this.form.company_name_filter,
          cnpj: this.form.identifier_company,
          data_inicio: this.form.date_start,
          data_fim: this.form.date_end,
          unidade_operacional: this.form.operating_unit.id_unidade,
          status: this.form.status,
          porPagina: 10,
          pagina: 1,
        }

        this.$emit('filterTable', this.searchFilter)
      })
    },
    closeModalProcessedWorkOrders() {
      this.showModalProcessedWorkOrders = false;
    },
    openModalProcessedWorkOrders() {
      this.showModalProcessedWorkOrders = true;
    },
    downloadZipOs(item) {
      const idAgendamentoOrdemDeServico = item.idAgendamentoOrdemDeServico;
      const idAgendamento = item.idAgendamento;

      this.$http
          .get(
              this.$api.getDownloadOSProcessedByUser(idAgendamentoOrdemDeServico),
              { responseType: 'blob' }
          )
          .then((res) => {
            const blob = new Blob([res.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ordem_de_servico_'+idAgendamento+'.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.loadOSProcessedByUser();
          })
          .catch((error) => {
            console.error('Erro ao baixar o ZIP:', error);
          });
    }
  },
  watch: {
    filter() {
      this.start()
    },
    'errorApi.cnpj': function (cnpj) {
      if (cnpj !== undefined) {
        this.error.cnpj = cnpj
      }
    },
     'form.department'(novoDepartamento) {
      if (novoDepartamento && novoDepartamento.id_departamento) {
        this.getCampaigns()
        this.getUnits()

        this.form.campaign = ''
        this.form.operating_unit = ''
      } else {
        this.campaignOptions = []
        this.form.campaign = ''

        this.operatingOptions = []
        this.form.operating_unit = ''

        this.getUnits()
        this.getCampaigns()
      }
    }
  }
}
</script>

<style scoped>
.os-btn {
  background-color: #FF9110 !Important;
  border-color: #FF9110 !Important;
}
</style>
